import { jsx } from "react/jsx-runtime";
import {
  getNumberMaskedValue,
  useNumberMask
} from "@elliemae/ds-form-helpers-mask-hooks";
import _, { isNull } from "lodash";
import { useEffect, useState } from "react";
import { DSInputText } from "@elliemae/ds-form-input-text";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { Grid } from "@elliemae/ds-grid";
import { useFormState } from "react-hook-form";
import { useFieldVisibilityAndDisability } from "../utils/fieldVisibilityAndDisability";
import { inRange } from "../utils/utils";
const TargetPrice = ({
  renderedField,
  schemaForm,
  rules,
  id,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  type,
  ui,
  visible,
  disabled,
  disableCheck,
  visibleCheck,
  preview,
  rest
}) => {
  const NUMBER_VALUES = {
    allowNegative: rest?.isZeroBasedPricing,
    includeThousandsSeparator: false,
    integerLimit: rest?.isZeroBasedPricing ? 2 : 3,
    decimalLimit: 3,
    decimalPlaces: 3
  };
  const { isVisible, isDisabled } = useFieldVisibilityAndDisability({
    schemaForm,
    rules,
    visible,
    disabled,
    visibleCheck,
    disableCheck,
    preview
  });
  const { errors } = useFormState({ control: schemaForm.control });
  const errorMessage = _.get(errors, pathValue)?.message;
  const opts = NUMBER_VALUES || void 0;
  const stringValue = String(renderedField?.value ?? "");
  const [value, setValue] = useState(
    opts ? getNumberMaskedValue(stringValue, opts) : stringValue
  );
  useEffect(() => {
    setValue(opts ? getNumberMaskedValue(stringValue, opts) : stringValue);
  }, [renderedField?.value]);
  const inputProps = useNumberMask({
    valueSetter: setValue,
    ...opts
  });
  const textboxUpdateLogic = (e) => {
    const targetLabel = schemaForm.getValues("loanInformation.targetLabel");
    const targetValue = parseFloat(e.target.value);
    if (targetLabel) {
      if (isNull(targetValue)) {
        schemaForm.setError(id, {
          type: "manual",
          message: "Required field"
        });
      } else if (targetLabel === "Price" && !rest?.isZeroBasedPricing && !inRange(targetValue, 80, 120)) {
        schemaForm.setError(id, {
          type: "manual",
          message: "Between 80 - 120"
        });
      } else if (targetLabel === "Price" && rest?.isZeroBasedPricing && !inRange(targetValue, -20, 20)) {
        schemaForm.setError(id, {
          type: "manual",
          message: "Between -20 - 20"
        });
      } else {
        schemaForm.clearErrors(id);
      }
    }
    renderedField.onChange(e);
  };
  function safeParseNumber(input) {
    const cleaned = input.replace(/[^0-9.-]/g, "");
    const isParsable = cleaned && /^-?\d*\.?\d*$/.test(cleaned) && // allows valid floats or incomplete inputs
    !["-", ".", "-."].includes(cleaned);
    return isParsable ? safeParseFloat(cleaned) : null;
  }
  function safeParseFloat(str) {
    const trimmed = str.trim();
    if (/^[-+]?0(\.0*)?$/.test(trimmed)) {
      return trimmed.startsWith("-") ? -0 : 0;
    }
    const num = Number(trimmed);
    return isNaN(num) ? null : num;
  }
  return /* @__PURE__ */ jsx(Grid, { span: ui.col_size, style: { display: isVisible ? "block" : "none" }, children: /* @__PURE__ */ jsx(
    DSFormLayoutBlockItem,
    {
      name,
      label,
      required,
      feedbackMessage,
      hasError: !!errors[id] || !!errorMessage,
      validationMessage: errors[id]?.message?.toString() || errorMessage,
      children: /* @__PURE__ */ jsx(
        DSInputText,
        {
          ...renderedField,
          "data-testid": "textbox-price",
          value: opts ? value : renderedField?.value ?? "",
          ...opts ? inputProps : {},
          onChange: (e) => {
            inputProps.onChange(e);
            const numericValue = ["-0", "-0.", "-", "-.", ".", ""].includes(
              e.target.value
            ) ? e.target.value : safeParseNumber(e.target.value);
            textboxUpdateLogic({
              ...e,
              target: { ...e.target, value: numericValue }
            });
          },
          disabled: isDisabled,
          id: pathValue
        }
      )
    }
  ) });
};
export {
  TargetPrice
};
